import {useMutation} from "@tanstack/react-query";
import {CodeAPI} from "../api/code.api";

export const useValidateCodeMutation = () =>
  useMutation({
    mutationFn: CodeAPI.validateCode,
  });
